import React from 'react';

import KPISkeletonLoader from 'components/utility/ContentLoader/KPILoader/KPILoader';
import { KPIListWrapper, KPIList } from 'components/Overview/KPIs/shared.style';
import KPI from '../shared/KPI';

interface IRadioKPIs {
  value: number;
  change: number;
  isPending: boolean;
  title: string;
}

/**
 * This component renders KPI's for the Radio Performance block on Overview pages.
 *
 * @param props
 * @param {number} props.value the value
 * @param {number} props.value the change value
 * @param {bool} props.isPending if true the component will render its loading state
 * @param {string} props.title the title that describes the meaning of the given value and change
 */
const RadioKPIs: React.FC<IRadioKPIs> = (props) => {
  const { value, change, isPending, title } = props;

  if (isPending) {
    return <KPISkeletonLoader />;
  }

  return (
    <KPIListWrapper>
      <KPIList>
        <KPI title={title} value={value} change={change} />
      </KPIList>
    </KPIListWrapper>
  );
};

export default RadioKPIs;
